module.exports = __webpack_public_path__ + "img/note.6954f103.png";